<button
  type="button"
  hlmBtn
  variant="outline"
  size="lg"
  class="h-10 w-full gap-3"
  (click)="triggerApple()"
  [attr.aria-label]="'AUTH.CONTINUE_WITH_APPLE' | translate">
  <span class="flex size-5 shrink-0 items-center justify-center" aria-hidden="true">
    <svg class="block size-5" width="20" height="20" viewBox="0 0 256 315" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(53,0)">
        <g transform="scale(0.92)">
          <path d="M213.8 167.1c-.3-33.6 14.8-58.9 45-77.6-16.9-24.6-42.3-38.1-76.1-40.6-31.9-2.5-66 18.5-78.7 18.5-13.3 0-44.1-17.7-68.3-17.2C7.3 50.7-21 69-34.1 99.8-57.7 151.6-34 216.4-.1 255.2c16.2 18.9 35.4 40.2 60.9 39.3 24-1 33-12.7 62.1-12.7 28.9 0 37.3 12.7 62.8 12.3 26-.4 42.4-19 58.2-38 10-12.3 17.6-25.3 22.9-39.2-67.4-25.5-53-98.1-52.9-99.8z" fill="currentColor"/>
          <path d="M173.5 32.3c15.6-18.9 14.2-36.1 13.7-42.3-13.2.8-28.5 9-37.6 20-9.8 11.6-15.7 25.9-14.4 41.8 14.8 1.2 29-6.6 38.3-19.5z" fill="currentColor"/>
        </g>
      </g>
    </svg>
  </span>
  <span>{{ 'AUTH.CONTINUE_WITH_APPLE' | translate }}</span>
</button>
